// components/RecaptchaProvider.js
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';

export default function RecaptchaProvider({children}) {
    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
            scriptProps={{
                async: true,
                defer: true,
                appendTo: 'body',
            }}
        >
            {children}
        </GoogleReCaptchaProvider>
    );
}